import UsersAssociationPage from "./UsersAssociationPage";

export default UsersAssociationPage;
